<template>
  <div class="container">
    <breadcrumbs :breadcrumbs="breadcrumbs" />
    <h1>{{ $t('news') }}</h1>
    <div class="news-index-items" v-for="newsItem in news.results || []">
      <span class="date">{{ newsItem.date|formatDateNews }}</span>
      <span class="name">{{ getNewsLocaleData(newsItem).title }}</span>
      <span><nuxt-link :to="localePath(`/news/${newsItem.id}`)">{{ getNewsLocaleData(newsItem).intro }}</nuxt-link></span>
    </div>
    <div v-if="news.count" class="pagination">
      <paginator :page="page" :items-per-page="news.page_size" :show-all-page="false"
                 :total-items="news.count" @change-page="changePage" />
    </div>
  </div>
</template>

<script>
import {rememberExpiresMixin} from "@/mixins";
import {NewsItem} from '@/models/news';

import Breadcrumbs from '@/components/breadcrumbs';
import Paginator from '@/components/paginator';

export default {
  components: {
    Breadcrumbs,
    Paginator,
  },
  mixins: [rememberExpiresMixin],
  data() {
    return {
      news: {},
      breadcrumbs: [{
        name: this.$t('all_news'),
        link: this.localePath('/news/'),
      }],
    }
  },
  mounted() {
    this.fetchNews(true);
  },
  computed: {
    page() {
      return parseInt(this.$route.query.page || 1);
    },
  },
  head() {
    return {
      title: this.$t('news'),
    }
  },
  methods: {
    fetchNews(countLoading) {
      NewsItem.config({count_loading: countLoading}).params({...this.$route.query}).first()
        .then((response) => this.news = response)
        .catch((e) => {
          if (this.page > 1) {
            this.changePage(this.page - 1);
          }
        });
    },
    changePage(page) {
      let query = {...this.$route.query, page: page};
      if (query.page === 1) {
        delete query.page;
      }
      this.$router.replace({path: this.$route.path, query: query})
        .catch(() => {})
        .finally(() => this.fetchNews(false));
    },
    getNewsLocaleData(newsItem) {
      return newsItem.news_item_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
  },
}
</script>
